/** @format */

import React, { useState } from 'react';
import { IoClose, IoLogoWhatsapp } from 'react-icons/io5';
import '../../css/modals/PormoModal.css';

const PromoModal = () => {
  const [close, setClose] = useState(false);
  const [closer, setCloser] = useState(true);

  const handleClose = () => {
    setClose(true);
    setTimeout(() => {
      setCloser(false);
    }, 500);
  };


  const handleClickOutside = (e) => {
    if (e.target.className === 'promo-modal') {
      setClose(true);
      setTimeout(() => {
        setCloser(false);
      } , 500);
    }
  }

  return (
    <div
      className='promo-modal'
      style={{
        display: `${closer ? 'flex' : 'none'}`,
      }}
        onClick={handleClickOutside}
      >
      <div
        className={`promo-modal-container ${close ? 'close' : ''}`}>
        <button className='promo-modal-closer' onClick={handleClose}>
          <IoClose />
        </button>
        <div className='promo-modal-buttons'>
          <a
            href='https://wa.link/cqsruy'
            target={'_blank'}
            rel='noreferrer'
            className='promo-modal-wpp'>
            <IoLogoWhatsapp style={{ marginRight: '1ch' }} />
            Incríbete
          </a>
          <p
            style={{
              cursor: 'pointer',
            }}
            onClick={handleClose}>
            Seguir en la página &gt;
          </p>
        </div>
      </div>
    </div>
  );
};

export default PromoModal;
